import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { environment } from "src/environments/environment";
import { SocialLogin } from "@capgo/capacitor-social-login";

@Injectable({
  providedIn: "root",
})
export class SsoAuthService {
  private initPromise: Promise<void> | null = null;

  // iOS needs its own OAuth client; web + Android only need the web client
  get isGoogleEnabled(): boolean {
    if (!environment.google_web_client_id) return false;
    if (Capacitor.getPlatform() === "ios") {
      return !!environment.google_ios_client_id;
    }
    return true;
  }

  initialize(): Promise<void> {
    if (!this.isGoogleEnabled) return Promise.resolve();
    if (!this.initPromise) {
      this.initPromise = SocialLogin.initialize({
        google: {
          webClientId: environment.google_web_client_id,
          iOSClientId: environment.google_ios_client_id || undefined,
          iOSServerClientId: environment.google_web_client_id,
          mode: "online",
        },
      }).catch((error) => {
        this.initPromise = null;
        throw error;
      });
    }
    return this.initPromise;
  }

  // Returns the Google idToken, or null if the user cancelled / it failed
  async signInWithGoogle(): Promise<string | null> {
    await this.initialize();

    // Clear the cached account so the account picker is always shown
    if (Capacitor.isNativePlatform()) {
      await SocialLogin.logout({ provider: "google" }).catch(() => {});
    }

    const res = await SocialLogin.login({ provider: "google", options: {} });
    if (res.result.responseType === "online" && res.result.idToken) {
      return res.result.idToken;
    }
    return null;
  }
}
